export default __webpack_public_path__ + "static/media/payment-mastercard.f982f579.svg";